import RequestModule from '@/assets/libs/requestModule'
import Util from '@/assets/libs/util'
import store from '@/store'

let syncCachedImagesPromise = null

const withCacheBuster = function (url, cacheBuster) {
  if (!url || !cacheBuster) return url

  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}v=${cacheBuster}`
}

const addImagesCacheBuster = function (images, cacheBuster) {
  if (!images || !cacheBuster) return images

  return {
    ...images,
    large: withCacheBuster(images.large, cacheBuster),
    small: withCacheBuster(images.small, cacheBuster)
  }
}

const addMenuImagesCacheBuster = function (menu, cacheBuster) {
  if (!menu?.groups || !cacheBuster) return menu

  return {
    ...menu,
    groups: menu.groups.map(group => ({
      ...group,
      groupImages: addImagesCacheBuster(group.groupImages, cacheBuster),
      products: (group.products || []).map(product => ({
        ...product,
        productImages: addImagesCacheBuster(product.productImages, cacheBuster)
      })),
      subGroups: (group.subGroups || []).map(subGroup => ({
        ...subGroup,
        subGroupImages: addImagesCacheBuster(subGroup.subGroupImages, cacheBuster),
        products: (subGroup.products || []).map(product => ({
          ...product,
          productImages: addImagesCacheBuster(product.productImages, cacheBuster)
        }))
      }))
    }))
  }
}

async function syncCachedImages () {
  if (!syncCachedImagesPromise) {
    syncCachedImagesPromise = RequestModule.postRequest('menu/syncCachedImages')
      .finally(() => {
        syncCachedImagesPromise = null
      })
  }

  return syncCachedImagesPromise
}

async function loadMenu (forceDefaultMenu = false, options = {}) {
  const {
    cacheBuster = null,
    preserveCurrentMenu = false,
    silent = false,
    syncImages = true
  } = options

  try {
    const user = store.getters.getUser
    const payload = {
      consumerType: (forceDefaultMenu || !user?.consumerType) ? 'T' : user.consumerType,
      hour: Util.getHour()
    }

    const response = await RequestModule.postRequest('menu/search', payload)

    // coloca o tipo de consumidor no menu
    response.data.consumerType = payload.consumerType
    response.data = addMenuImagesCacheBuster(response.data, cacheBuster)

    store.commit('setMenu', response?.data)

    if (syncImages) {
      refreshMenuImagesInBackground(forceDefaultMenu)
    }

    return response
  } catch (error) {
    const errStatus = error?.response?.data?.error
    const message = error?.response?.data?.message

    if (!silent) {
      if (!errStatus && message) {
        Util.showErrorNotification(message)
      } else {
        Util.showErrorNotification('Cardápio não disponível para compra antecipada.')
      }
    }

    if (!preserveCurrentMenu) {
      store.commit('setMenu', null)
    }

    return false
  }
}

function refreshMenuImagesInBackground (forceDefaultMenu = false) {
  syncCachedImages()
    .then(() => loadMenu(forceDefaultMenu, {
      cacheBuster: Date.now(),
      preserveCurrentMenu: true,
      silent: true,
      syncImages: false
    }))
    .catch(() => false)
}

export {
  loadMenu,
  syncCachedImages
}
